export const M1_UNIT_16 = {
  id: "u16-module-review",
  title: "Unidad 16: Module 1 Review",
  topic: "Full Revision (Units 1-15)",
  iconType: "trophy",
  grammarImage: "/u16-module1-review.jpg",
  grammarText: "Repaso total: Personal Info + Family + Jobs + Routines + Free Time.",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: IDENTITY (Name, Age, Country)
    // Enfoque: Presentación personal básica.
    // ----------------------------------------------------------------------
    {
      id: "u16-set1",
      title: "Set 1: Who are you?",
      questions: [
        {
          type: "match",
          q: "Match Q&A",
          pairs: [
            { left: "What is your name?", right: "I am Alex" },
            { left: "Where are you from?", right: "I am from Spain" },
            { left: "How old are you?", right: "I am 25" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I ___ from Mexico. I am ___.", options: ["am/Mexican", "is/Mexico", "are/Mexican"], a: "am/Mexican" },
        { type: "input", q: "She is from Japan. She is ___ (nationality).", a: "Japanese" },
        { type: "order", q: "Ordena", words: ["My", "name", "is", "Sarah."], a: "My name is Sarah." },
        { type: "mc", q: "We ___ American.", options: ["are", "is", "am"], a: "are" },
        { type: "input", q: "He ___ (tener) 30 years old. (Careful! Use 'to be')", a: "is" },
        { type: "match",
          q: "Numbers",
          pairs: [
            { left: "12", right: "Twelve" },
            { left: "20", right: "Twenty" },
            { left: "100", right: "One hundred" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["Where", "are", "you", "from?"], a: "Where are you from?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: FAMILY & POSSESSION (My/Your/His)
    // Enfoque: Relaciones y pertenencia.
    // ----------------------------------------------------------------------
    {
      id: "u16-set2",
      title: "Set 2: Family & Things",
      questions: [
        {
          type: "match",
          q: "Family Tree",
          pairs: [
            { left: "Mom & Dad", right: "Parents" },
            { left: "Dad's Brother", right: "Uncle" },
            { left: "Sister's Son", right: "Nephew" }
          ],
          a: "completed"
        },
        { type: "mc", q: "This is my sister. ___ name is Ana.", options: ["Her", "His", "Your"], a: "Her" },
        { type: "input", q: "That is my father. ___ (Su) car is red.", a: "His" },
        { type: "order", q: "Ordena", words: ["This", "is", "my", "mother's", "house."], a: "This is my mother's house." },
        { type: "mc", q: "These keys are ___ (mine).", options: ["mine", "my", "me"], a: "mine" },
        { type: "input", q: "We love ___ (nuestro) dog.", a: "our" },
        { type: "match",
          q: "Possessives",
          pairs: [
            { left: "Tom's car", right: "His car" },
            { left: "Ana's bag", right: "Her bag" },
            { left: "The dog's ball", right: "Its ball" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["Those", "are", "their", "books."], a: "Those are their books." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: JOBS & WORKPLACES (Work)
    // Enfoque: Profesiones y lugares.
    // ----------------------------------------------------------------------
    {
      id: "u16-set3",
      title: "Set 3: Career",
      questions: [
        {
          type: "match",
          q: "Match Job to Place",
          pairs: [
            { left: "Doctor", right: "Hospital" },
            { left: "Teacher", right: "School" },
            { left: "Waiter", right: "Restaurant" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I am ___ engineer.", options: ["an", "a", "the"], a: "an" },
        { type: "input", q: "A farmer works ___ (preposition) a farm.", a: "on" },
        { type: "mc", q: "She works ___ an office.", options: ["in", "on", "at"], a: "in" },
        { type: "order", q: "Ordena", words: ["He", "is", "a", "police", "officer."], a: "He is a police officer." },
        { type: "match",
          q: "Job Actions",
          pairs: [
            { left: "Chef", right: "Cooks food" },
            { left: "Pilot", right: "Flies planes" },
            { left: "Vet", right: "Helps animals" }
          ],
          a: "completed"
        },
        { type: "input", q: "I work ___ (con) children.", a: "with" },
        { type: "order", q: "Ordena", words: ["Where", "do", "you", "work?"], a: "Where do you work?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: DAILY ROUTINE (Present Simple)
    // Enfoque: Verbos de rutina y hora.
    // ----------------------------------------------------------------------
    {
      id: "u16-set4",
      title: "Set 4: Daily Life",
      questions: [
        {
          type: "match",
          q: "Order the Day",
          pairs: [
            { left: "1. Morning", right: "Wake up" },
            { left: "2. Afternoon", right: "Work/Lunch" },
            { left: "3. Night", right: "Sleep" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I ___ up at 7:00.", options: ["get", "gets", "getting"], a: "get" },
        { type: "mc", q: "She ___ to work at 8:00.", options: ["goes", "go", "going"], a: "goes" },
        { type: "input", q: "We ___ (tener) breakfast together.", a: "have" },
        { type: "input", q: "He ___ (ver) TV in the evening.", a: "watches" },
        { type: "order", q: "Ordena", words: ["I", "brush", "my", "teeth."], a: "I brush my teeth." },
        { type: "match",
          q: "Time",
          pairs: [
            { left: "7:00", right: "Seven o'clock" },
            { left: "7:30", right: "Half past seven" },
            { left: "7:45", right: "Quarter to eight" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["What", "time", "is", "it?"], a: "What time is it?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: WEEK & FREE TIME (Do/Does)
    // Enfoque: Negativos y Preguntas.
    // ----------------------------------------------------------------------
    {
      id: "u16-set5",
      title: "Set 5: Week & Hobbies",
      questions: [
        {
          type: "match",
          q: "Match Frequency",
          pairs: [
            { left: "Always", right: "Every day" },
            { left: "Sometimes", right: "50%" },
            { left: "Never", right: "0%" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I ___ work on Sundays.", options: ["don't", "doesn't", "not"], a: "don't" },
        { type: "mc", q: "___ she play tennis?", options: ["Does", "Do", "Is"], a: "Does" },
        { type: "input", q: "We go to the cinema ___ (preposition) Friday.", a: "on" },
        { type: "input", q: "He ___ (jugar) soccer.", a: "plays" },
        { type: "order", q: "Ordena", words: ["I", "never", "eat", "meat."], a: "I never eat meat." },
        { type: "match",
          q: "Hobbies",
          pairs: [
            { left: "Go", right: "Swimming" },
            { left: "Play", right: "Guitar" },
            { left: "Do", right: "Yoga" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["Do", "you", "like", "music?"], a: "Do you like music?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: READING COMPREHENSION (Story)
    // Enfoque: Entender un texto completo.
    // ----------------------------------------------------------------------
    {
      id: "u16-set6",
      title: "Set 6: Meet Daniel",
      questions: [
        {
          type: "mc",
          q: "READING:\n'Hi! I'm Daniel. I am 30 years old and I am from Italy. I live in Rome.'\n\nQuestion: Where is Daniel from?",
          options: ["Italy", "Spain", "USA"],
          a: "Italy"
        },
        {
          type: "mc",
          q: "READING:\n'I am a chef. I work in a big restaurant. I cook pasta and pizza.'\n\nQuestion: What is his job?",
          options: ["Chef", "Waiter", "Driver"],
          a: "Chef"
        },
        {
          type: "blank",
          q: "READING:\n'I work from Tuesday to Sunday. I don't work on Monday.'\n\nQuestion: Daniel's free day is ___.",
          a: "Monday"
        },
        {
          type: "match",
          q: "Daniel's Life",
          pairs: [
            { left: "Job", right: "Chef" },
            { left: "City", right: "Rome" },
            { left: "Day off", right: "Monday" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["He", "cooks", "pizza", "and", "pasta."], a: "He cooks pizza and pasta." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: ERROR CORRECTION (Grammar Check)
    // Enfoque: Detectar errores comunes.
    // ----------------------------------------------------------------------
    {
      id: "u16-set7",
      title: "Set 7: Fix the Mistakes",
      questions: [
        { type: "mc", q: "Incorrect: 'She have a car'. Correct: ___", options: ["She has a car", "She haves a car"], a: "She has a car" },
        { type: "mc", q: "Incorrect: 'He don't work'. Correct: ___", options: ["He doesn't work", "He not work"], a: "He doesn't work" },
        { type: "input", q: "Correct: 'I am 20 years'. -> I am 20 years ___.", a: "old" },
        { type: "input", q: "Correct: 'She watch TV'. -> She ___ TV.", a: "watches" },
        { type: "match",
          q: "Fix the Preposition",
          pairs: [
            { left: "IN Monday", right: "ON Monday" },
            { left: "AT the morning", right: "IN the morning" },
            { left: "TO home", right: "Home (No 'to')" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["Where", "does", "she", "live?"], a: "Where does she live?" },
        { type: "mc", q: "Incorrect: 'This are my books'. Correct: ___", options: ["These are my books", "This is my books"], a: "These are my books" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: TRANSLATION CHALLENGE (Español -> Inglés)
    // Enfoque: Producción.
    // ----------------------------------------------------------------------
    {
      id: "u16-set8",
      title: "Set 8: Translator",
      questions: [
        { type: "order", q: "Traduce: 'Ella es mi hermana.'", words: ["She", "is", "my", "sister."], a: "She is my sister." },
        { type: "order", q: "Traduce: 'Yo no juego tenis.'", words: ["I", "don't", "play", "tennis."], a: "I don't play tennis." },
        { type: "input", q: "Traduce: '¿De dónde eres?' -> Where ___ you from?", a: "are" },
        { type: "input", q: "Traduce: 'Me gusta el café.' -> I ___ coffee.", a: "like" },
        { type: "match",
          q: "Translate",
          pairs: [
            { left: "Every day", right: "Todos los días" },
            { left: "Usually", right: "Usualmente" },
            { left: "Never", right: "Nunca" }
          ],
          a: "completed"
        },
        { type: "mc", q: "Traduce: 'Son las tres y media.'", options: ["It's half past three", "It's three thirty", "Both are correct"], a: "Both are correct" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: CONVERSATION BUILDER (Dialogue)
    // Enfoque: Interacción fluida.
    // ----------------------------------------------------------------------
    {
      id: "u16-set9",
      title: "Set 9: The Interview",
      questions: [
        { type: "mc", q: "A: Hello! What is your name?", options: ["I am John.", "He is John.", "It is John."], a: "I am John." },
        { type: "input", q: "A: Nice to meet you. Where do you ___ (vivir)?", a: "live" },
        { type: "mc", q: "B: I live in New York. I ___ a teacher.", options: ["am", "is", "work"], a: "am" },
        { type: "order", q: "A: Ask about routines:", words: ["What", "time", "do", "you", "start?"], a: "What time do you start?" },
        { type: "blank", q: "B: I start ___ 8:00 AM. (at)", a: "at" },
        { type: "match",
          q: "Conversation Flow",
          pairs: [
            { left: "How are you?", right: "Fine, thanks" },
            { left: "Do you like it?", right: "Yes, I do" },
            { left: "See you later", right: "Bye!" }
          ],
          a: "completed"
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: THE FINAL EXAM (Mastery)
    // Enfoque: Demostrar que estás listo para el Módulo 2.
    // ----------------------------------------------------------------------
    {
      id: "u16-set10",
      title: "Set 10: Graduation",
      questions: [
        { type: "order", q: "Build a complex sentence:", words: ["My", "sister", "usually", "gets", "up", "at", "six."], a: "My sister usually gets up at six." },
        { type: "input", q: "Complete: I have a car but I ___ (negativo) drive to work.", a: "don't" },
        { type: "match",
          q: "Final Review",
          pairs: [
            { left: "Subject", right: "I / You / She" },
            { left: "Verb", right: "Work / Play / Go" },
            { left: "Object", right: "Tennis / TV / Home" }
          ],
          a: "completed"
        },
        { type: "mc", q: "Are you ready for Module 2?", options: ["Yes, I am!", "Yes, I do!", "Yes, I have!"], a: "Yes, I am!" },
        { type: "order", q: "Congratulations!", words: ["You", "finished", "Module", "One!"], a: "You finished Module One!" }
      ]
    }
  ]
};